import './index.less';

import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';

import ApplicationInfoTab from './ApplicationInfoTab';
import AttachmentTab from './AttachmentTab';
import DisbursementInfoTab from './DisbursementInfoTab';
import HistoryLogTab from './HistoryLogTab';

interface ApplicationDetailsTabProps {
  dataSource?: any[];
  applicationData?: any;
  ekycFilesData?: any;
  historyLogsData?: any;
  readOnlyMode?: boolean;
}

const ApplicationDetailsTab = ({
  dataSource,
  applicationData,
  ekycFilesData,
  historyLogsData,
  readOnlyMode = false,
}: ApplicationDetailsTabProps) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get('tab');

  const tabItems = [
    {
      label: 'Application Info',
      key: 'appInfo',
      children: (
        <ApplicationInfoTab applicationData={applicationData} readOnlyMode={readOnlyMode} />
      ),
    },
    {
      label: 'Disbursement Info',
      key: 'disbursementInfo',
      children: <DisbursementInfoTab />,
    },
    {
      label: 'Attachment',
      key: 'attachment',
      children: <AttachmentTab applicationData={applicationData} ekycFilesData={ekycFilesData} />,
    },
    {
      label: 'History Log',
      key: 'historyLog',
      children: (
        <HistoryLogTab applicationData={applicationData} historyLogsData={historyLogsData} />
      ),
    },
  ];

  return <Tabs defaultActiveKey={activeTab ?? 'appInfo'} items={tabItems} />;
};

export default ApplicationDetailsTab;
